import { render, staticRenderFns } from "./Nine-red.vue?vue&type=template&id=227b6868&scoped=true&"
import script from "./Nine-red.vue?vue&type=script&lang=js&"
export * from "./Nine-red.vue?vue&type=script&lang=js&"
import style0 from "./Nine-red.vue?vue&type=style&index=0&id=227b6868&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227b6868",
  null
  
)

export default component.exports